import componentize from '../utils/componentize';
import $ from 'jquery';
/* global window */
/* global document */
export default function () {
    componentize({
        query: '.video-button',
        attachedCallback: function () {
            // This uses transform instead of show/hide
            // because otherwise the code to hover over the video iframe is broken
            this.addEventListener('click', () => {
                if ($('.video-modal').hasClass('visible')) {
                    $('.video-modal').removeClass('visible');
                } else {
                    $('.video-modal').addClass('visible');
                }
            });
        }
    });
    componentize({
        query: '.inline-video',
        _visible: false,
        hasUnmuted: false,
        attachedCallback: function () {
            window.addEventListener('message', this.messageHandler.bind(this));
            window.addEventListener('scroll', this.onScroll.bind(this));
            this.key = Math.random();

            let $this = $(this);
            this.$ = $this;
            $this.find('.unmute-button').on('click', () => {
                this.sendMessage('unmute');
            });
        },
        sendMessage: function (command, payload) {
            let key = this.key;
            this.$.find('.video-frame').each(function () {
                let message = {
                    command: command,
                    payload: payload,
                    key: key
                };
                this.contentWindow.postMessage(message, '*');
            });
        },
        messageHandler: function (event) {
            if (event.data.key !== this.key) return;
            let command = event.data.command;
            if (command === 'unmute') {
                this.removeMuteButton();
            }
        },
        onScroll: function () {
            var elementTop = this.getBoundingClientRect().top;
            var elementBottom = this.getBoundingClientRect().bottom;

            if (elementTop >= 0 && elementBottom <= window.innerHeight) {
                this.setVisible(true);
            } else {
                this.setVisible(false);
            }
        },
        setVisible: function (value) {
            if (this._visible !== value) {
                this._visible = value;
                this.toggleAutoplay(value);
            }
        },
        toggleAutoplay: function (value) {
            this.sendMessage(value ? 'play' : 'pause', {hasUnmuted: this.hasUnmuted});
        },
        removeMuteButton: function () {
            this.$.find('.unmute-button').hide();
            this.hasUnmuted = true;
        }
    });
}
